import { React, useState, useRef } from "react";
import './NewsPost_UI.css';
import { NewsPost_Data } from '../NewsPost_Data';

import Navbar from "../../../CommonComponent/Navbar/Navbar";
import Footer from "../../../CommonComponent/Footer/footer";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";

import { useParams } from "react-router-dom";


const NewsPost_UI = () => {

    const { News_Post_Id } = useParams();
    const Current_Post = NewsPost_Data[News_Post_Id] || null;

    const News_Post_Title = Current_Post?.N_Post_Title || null;
    const News_Post_Date = Current_Post?.N_Post_Date || null;
    const News_Post_Author = Current_Post?.N_Post_Author || null;
    const News_Post_SHARE = Current_Post?.N_Post_SHARE || null;
    const News_Post_Content = Current_Post?.N_Post_Content || null;
    const NewsPost_EndImg = Current_Post?.N_End_PostIMG || null;

    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="NewsPost_Container">
                {Current_Post ? (
                    <div className="content_wrapper">
                        <div className="NewsPost_Text">
                            {News_Post_Title != null && <h1 className="NewsPost_Title">{News_Post_Title}</h1>}
                            <div className="NewsPost_Top-bar">
                                <div className="NP_TopB_Left">
                                    <p><b>Post: {News_Post_Date}</b></p>
                                    <p>Author: {News_Post_Author}</p>
                                </div>
                                <div className="NP_TopB_Right">
                                    <p>SHARE</p>
                                    <p>[{News_Post_SHARE}]</p>
                                </div>
                            </div>
                            {News_Post_Content != null && (
                                <div className="NP_conetnt">
                                    {News_Post_Content}
                                </div>
                            )}
                        </div>
                        {NewsPost_EndImg != null && (
                            <div className="NP_EndImg">
                                <img src={NewsPost_EndImg} alt={News_Post_Title} />
                            </div>
                        )}
                    </div>
                ) : (
                    <h3>Error 404! Page not Found</h3>
                )}
            </div>
            <Footer />
        </>
    );
}

export default NewsPost_UI;